import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/notificationPanelStyle';
import Button from 'components/CustomButtons/Button';
import { getValueByKey } from 'utils/helpers';
import { INSIGHTS_PAGE_URL } from 'utils/const/ebu';
import { FAILED_REPORT_GENERATION, SUCCESSFUL_REPORT_GENERATION } from './constant';
import { useHistory } from 'react-router-dom';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Cookies from 'js-cookie';
import axios from 'axios';
import { domainSelector } from 'redux/modules/settings/appConfig/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { getLanguage } from 'utils/language/language';
import { upIdSelector } from 'redux/modules/session/selectors';
import { processApiResponse } from 'utils/graphql';
import { setToast } from 'redux/modules/toast/actions';
import _ from 'lodash';
import { env } from 'config/app.config';
import apiConfig from 'utils/api/config';

// @ts-ignore
const useStyles = makeStyles(styles);

const NotificationButtons = ({
	type,
	notificationsLabels = {},
	parameters,
	hideNotification,
}: {
	type: string;
	notificationsLabels: any;
	parameters: Array<{ key: string; value: string }>;
	hideNotification: () => void;
}) => {
	const domainConfig = useSelector(domainSelector);
	const upId = useSelector(upIdSelector);
	const classes = useStyles();
	const history = useHistory();
	const referenceId = getValueByKey(parameters, 'referenceId');
	const incidentId = getValueByKey(parameters, 'incidentNumber');
	const dispatch = useDispatch();

	const downloadReport = async () => {
		const apiKey = domainConfig?.apiKey[env];
		const apiUrl = domainConfig?.featuresDomain?.ASYAD?.url ?? apiConfig.sources.graphQL[env];

		try {
			dispatch(
				setToast({
					error: false,
					label: notificationsLabels?.downloadReport?.fetching,
				})
			);
			const response = await axios.post(
				`${apiUrl}/reporting/graphql`,
				{
					query: `query DownloadReportById($id: String!) { download(referenceId: $id) { url: s3PreSignedUrl }}`,
					variables: {
						id: referenceId,
					},
				},
				{
					headers: {
						'content-type': 'application/json',
						'x-api-key': apiKey,
						'x-channel-id': 'EBU',
						'x-customer-id': upId,
						'x-device-id': 'EBU',
						'x-language': getLanguage(),
						'x-token': Cookies.get('correlationId'),
					},
				}
			);
			const { data, errorCode } = processApiResponse(response.data);
			if (errorCode) {
				dispatch(
					setToast({
						error: true,
						label:
							notificationsLabels?.downloadReport?.errors?.[errorCode] ||
							notificationsLabels?.downloadReport?.errors?.['DEFAULT_ERROR'],
					})
				);
				return;
			}

			const url = data?.download.url;
			if (!url) throw new Error('Download URL is not available.');

			const fileName = _.get(/[^/]+(?=\?)/.exec(url) ?? [], [0]) ?? referenceId;

			const fileResponse = await fetch(url);
			const blob = await fileResponse.blob();
			const objectUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (error) {
			dispatch(
				setToast({
					error: true,
					label: notificationsLabels?.downloadReport?.errors?.['DEFAULT_ERROR'],
				})
			);
		}
	};
	const viewReport = () => {
		/* direct navigation as that is a different application*/
		window.location.href = `${INSIGHTS_PAGE_URL}/${referenceId}`;
	};
	const viewIncident = () => {
		hideNotification();
		history.push({
			pathname: '/dashboard/history-of-complaints',
			search: `?incidentId=${incidentId}`,
		});
	};

	const isDownloadable = new RegExp(SUCCESSFUL_REPORT_GENERATION).test(type);
	const isReportAvailable = new RegExp(FAILED_REPORT_GENERATION).test(type) && incidentId;

	return referenceId ? (
		<div className={classes.buttonGroup}>
			{isDownloadable && (
				<Button color="tertiary-light-v2" onClick={downloadReport}>
					{notificationsLabels?.cta?.downloadReport}
				</Button>
			)}
			{isReportAvailable && (
				<Button color="tertiary-light-v2" onClick={viewIncident}>
					{notificationsLabels?.cta?.viewTicket}
				</Button>
			)}
			<Button color="tertiary-light" onClick={viewReport} withIcon>
				<>
					{notificationsLabels?.cta?.viewReport}
					<ArrowForwardIosIcon />
				</>
			</Button>
		</div>
	) : null;
};

export default NotificationButtons;
